<template>
  <!-- Stránka vytvoření certifikátu — Blade app-nav je nad #app, vlastní navbar odstraněn -->
  <div class="verif-page">

    <main class="verif-page__main">
      <div class="verif-card">

        <!-- Tlačítko zpět na nástěnku -->
        <div class="verif-card__back">
          <button class="auth-back-btn" @click="$router.push({ name: 'Dashboard' })">
            <img :src="iconChevronLeft" alt="">
            {{ $t('general.back') }}
          </button>
        </div>

        <!-- Záhlaví karty: ikona + nadpis + popis -->
        <div class="verif-card__header">
          <img :src="iconPlus" alt="" class="verif-card__icon icon-blue">
          <div>
            <h1 class="verif-card__title">{{ $t('dashboard.action_create') }}</h1>
            <p class="verif-card__subtitle">{{ $t('dashboard.action_create_sub') }}</p>
          </div>
        </div>

        <!-- Formulář pro vytvoření certifikátu -->
        <div class="verif-card__body">
          <FileUploadComponent @close="$router.push({ name: 'Dashboard' })" />
        </div>

      </div>
    </main>

  </div>
</template>

<script>
import iconPlus from '/public/img/new-design/icons/plus.svg';
import iconChevronLeft from '/public/img/new-design/icons/chevron-left.svg';
import { loadingState } from '@/loading.js';

export default {
  mounted() {
    loadingState.active = false;
  },

  data() {
    return {
      iconPlus,
      iconChevronLeft,
    };
  },
};
</script>